/**
 * Hero of the Ryerson Commitment landing page, `/why-ryerson/ryerson-commitment/`
 * (`src/pages/why-ryerson/ryerson-commitment/index.tsx`, its only importer): breadcrumb, title,
 * subtitle and description from `./Content.tsx` in the visitor's language. Below `lg` it renders
 * `./RyersonCommitmentMobile.tsx`, from `lg` up `./RyersonCommitmentDesktop.tsx`.
 *
 * Not to be confused with `src/components/Shared/RyersonCommitment/RyersonCommitment.tsx`, the
 * card grid on the Why Ryerson landing page that links to this page and its sub-pages.
 */
import React from "react";
import { Media } from "@ryerson/frontend.next";
import { RyersonCommitmentContent } from "./Content";
import RyersonCommitmentDesktop from "./RyersonCommitmentDesktop";
import RyersonCommitmentMobile from "./RyersonCommitmentMobile";
import { useApplication } from "@ryerson/frontend.application";

/** Theme background of the hero's `ContentSection`. */
export type backgroundType = "primary" | "secondary" | "tertiary";

/** One language's hero copy; also the props of the desktop and mobile layouts. */
export interface RyersonCommitmentProps {
	/** Defaults to `tertiary` in both layouts; `./Content.tsx` never sets it. */
	background?: backgroundType;
	/** The page's `h1`. */
	title: string;
	subtitle: string;
	description: string;
}

/** Renders the hero in the visitor's language. Takes no props. */
const RyersonCommitment: React.FC = () => {
	const {
		localization: { language },
	} = useApplication();

	return (
		<>
			<Media lessThan="lg">
				<RyersonCommitmentMobile {...RyersonCommitmentContent[language]} />
			</Media>
			<Media greaterThanOrEqual="lg">
				<RyersonCommitmentDesktop {...RyersonCommitmentContent[language]} />
			</Media>
		</>
	);
};

export default RyersonCommitment;
